import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AppSwitcherComponent } from './app-switcher/app-switcher.component';
import { LiveSupportDetailComponent } from './live-support-detail/live-support-detail.component';
import { RichTextComponent } from './rich-text/rich-text.component';
import { VersionExpiredComponent } from './version-expired/version-expired.component';

@NgModule({
  imports: [AngularSvgIconModule.forRoot(), CommonModule, RouterModule],
  declarations: [AppSwitcherComponent, LiveSupportDetailComponent, RichTextComponent, VersionExpiredComponent],
  exports: [
    AppSwitcherComponent,
    AngularSvgIconModule,
    LiveSupportDetailComponent,
    RichTextComponent,
    VersionExpiredComponent,
  ],
})
export class UiModule {}
